import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
body {
  margin: 0;
}
iframe{
  border:none!important;
}
.whitebubble{
  border-radius: 50px;
  background-color: #323f5f;
  cursor: pointer;
  will-change: background-color;
  transition: background-color 0.3s ease 0s;
  border: 1px solid #323f5f;
  padding: 6px;
  font-weight: bold;
  line-height: 1;
  font-size: 13px;
  color: white !important;
}
.ant-carousel .slick-next:hover,.ant-carousel .slick-prev:hover{
  color:#323F5F!important;
}
.ant-tabs-tabpane {
  outline: none;
  margin-bottom: 50px!important;
  float:left;
  width:100%;
  position: relative;
  border-top: 1.5px solid #6B8637;
}
.ant-drawer {
z-index:999999;
}
.ant-dropdown {
  border-radius: 4rem;
  overflow: hidden;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {
  text-align: center !important;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:first-child {
  margin-top: 0.5rem;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:last-child {
  margin-bottom: 0.5rem;
}
.ant-carousel{
  width:100%;
}
  .ant-tabs {
    &-nav {
      display: flex;
  
      .ant-tabs-tab {
        flex-grow: 1;
        margin-right: 0px;
        width: 98%;
        text-align: center;
      }
    }
  }
  .ant-image .ant-image-mask{
    width: 98%;
    margin: .25rem;
    border-radius: 1.5rem;
  }
  .ant-collapse-header::before{
    width:36px;
    height:36px;
    background:url('/img/routes/routes.png');
    background-repeat:no-repeat;
    background-position:center center;
    padding:15px;
    background-color:#cccc66;
    content:'1';
    color:transparent;
    border-radius:20px!important;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header{
    padding:0!important;
    line-height: 35px;
  }
  .ant-collapse{
    background-color: transparent;
    border: none!important;
  }
  .ant-collapse-content {
    background-color: transparent;
    border-top: none!important;
    height:350px;
    overflow-y:scroll;
    max-width:100%;
}
  .ant-tabs>.ant-tabs-nav .ant-tabs-nav-list, .ant-tabs>div>.ant-tabs-nav .ant-tabs-nav-list {
    position: relative;
    display: flex;
    transition: transform .3s;
    width: 98%;
  }
  
 /* .car3d:not(.car3d1) .slick-current div img,.car3d .slick-current div{
    border-bottom-left-radius	:60px!important;
  }*/
  
  .car3dc .slick-slider{
    left:-50px;
  }
  .car3dc .slick-active div, .car3dc .slick-active img{
    width:40%;
    height:240px;
  }
  .car3dc .slick-active div img{
    padding:30px 50px;
    display:block;
    opacity:0.3;
   }
  
   .car3dc .slick-active div,.car3dc .slick-active img{
    width:100%;
    height:420px;
  }
  .car3dc .slick-current{
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.86) 0%, #FFFFFF 53.65%);
border-radius: 0px;
filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.45));
   }
   .car3dc .slick-next{
    top:210px !important;
    left: 66.5% !important;
    z-index:9999999!important;
   }
   .car3dc .slick-prev{
    top:210px !important;
    left: 31% !important;
    z-index:9999999!important;
   }
  .car3dc .slick-current div{
    height:auto;
   
   }
  .car3dc .slick-current div img{
   padding:0px;
   display:block;
   opacity:1;
   left:0px;
    right:0px;
    position:relative;
  }
  .ant-tabs-tab-active svg, .ant-tabs-tab:hover svg  {
   color: #B9BC66 !important;
  }
.ant-tabs-tab-btn span img {
    padding: 5px;
    width: 35px;
	  float: left;
}
.ant-tabs-tab-btn span span{
    background: rgb(239 248 223);
    backdrop-filter: blur(5px);
    padding: 10px;
    border-radius: 100% !important;
    border: 1px solid #475B1F !important;
    width: 55px;
    height: 55px;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
}
.ant-tabs-tab-btn:hover span img,.ant-tabs-tab-active  span img{
  filter: invert(1);
}
 .ant-tabs-tab-btn:hover span span,.ant-tabs-tab-active  span span{
 background:#475B1F !important;
}
.ant-tabs-tab-btn b {
	line-height: 3.4rem;
	margin: 0px 35px 0px 10px;
	color:block!important;
	font-weight:normal;
	font-size: 18px;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn b{
  color: black;
	font-weight: 700 !important;
}

.ant-tabs-tab-btn:hover b,.ant-tabs-tab:hover{
  color: black !important;
	font-weight: 700 !important;
}

audio{
    margin-bottom: 20px!important;
    float: left;
    position: relative;
	display:block;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list, .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
    width: auto;
    }

//////   for bottom border   ///////////
  .ant-tabs-ink-bar {
    height: 5px;
    background: none!important;
  }
.ant-tabs-top > .ant-tabs-nav::before, .ant-tabs-bottom > .ant-tabs-nav::before, .ant-tabs-top > div > .ant-tabs-nav::before, .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: none;
    content: '';
}

  /* Custom Coloring */

  .ant-carousel .slick-dots li button {
      opacity: 0.3;
      width:20px;
      height:20px;
      border-radius:50%;
      border:2px solid white;
      background-color: transparent;
  }
  .ant-carousel .slick-dots li.slick-active button {   
      opacity: 1;
      width:30px;
      height:30px;
      border-radius:50%;
      border:2px solid white;
      background-color: transparent;
      margin-top:-4px;
  }
  .ant-carousel .slick-dots li {
      margin-right: 16px;
  } 

  .ant-carousel .slick-dots-bottom {
    bottom: 140px;
  }

  .ant-carousel {
    .slick-next {
        &::before {
        content: '';
        }
    }
    .slick-prev { 
        &::before {
        content: '';
        }
    }
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector{
    border-radius: 20px;
  }
  
  .ant-select-selection-item {
    display: flex;
    justify-content: space-between;
    color: white !important;
    padding: 0rem !important;
  }

  .ant-select-selection-item > span > svg {
    // color: red !important;
    transform: rotate(90deg);
    // float: right !important;
  }

  .ant-drawer-body {
    padding: 4px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-button {
      background: #green
  }
  ::-webkit-scrollbar-track-piece {
      background: #888
  }
  ::-webkit-scrollbar-thumb {
      background: #eee
  }​

  .ant-col-24.ant-form-item-label, .ant-col-xl-24.ant-form-item-label, .ant-form-vertical .ant-form-item-label {
    display: none;
  }

  .result_message a {
    color: red !important;
  }

  @media only screen and (max-width: 600px) { 
    .ant-carousel .slick-prev {
      left:28vw !important;
      top: 200px;
      
      
    }
    .ant-carousel .slick-next {
      left: 42vw !important;
      top: 200px;
    }
    
    .slick-list {
      max-height: 355px;
    }

	  nav{
		position:relative;
		float:left;
		width:100%
	  }

    .car3dc .slick-slider{
      left:-22px;
    }

    .slick-current{
      width: 81vw !important;
      margin-left: -8vw;
    }

    .ant-select:not(.ant-select-customize-input) .ant-select-selector{
      margin-right: 1rem !important;
      margin-left: 0rem !important;
    }
  }
`;